export default __webpack_public_path__ + "static/media/footer-icon.822fb7b0.svg";